import React from "react";

function Link({text, url}) {
    return (
        <a target="_blank" href={url} rel="noreferrer">
            {text}
        </a>
    );
}

export default Link;
